// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.N4LUM{font-size:.875rem;text-align:right}.N4LUM .hwhpZ{color:var(--sui-color-blue)}.N4LUM .yQZ48{color:var(--anchore-color-gray-500)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"subheader": `N4LUM`,
	"cve": `hwhpZ`,
	"package": `yQZ48`
};
module.exports = ___CSS_LOADER_EXPORT___;
